const methods = {
  android: {
    desygner: [],
    webrand: []
  },
  ios: {
    webrand: [],
    desygner: [
      { funcName: 'sendFacebookCredentials', oldName: 'auth_facebook', usedBefore: '1.1.2' },
      { funcName: 'sendInstagramCredentials', oldName: 'auth_instagram', usedBefore: '1.1.2' },
      { funcName: 'editorLoaded', oldName: 'editor_loaded', usedBefore: '1.1.2' },
      { funcName: 'showTeam', oldName: 'show_team', usedBefore: '1.1.2' },
      { funcName: 'catchFile', oldName: 'catch_file', usedBefore: '1.1.2' },
      { funcName: 'closeEditor', oldName: 'close_overlay', usedBefore: '1.1.2' },
      { funcName: 'shareWithFb', oldName: 'share_with_fb', usedBefore: '1.1.2' },

      { funcName: 'design.template.update', oldName: 'design.template.updated', usedBefore: '1.2' },
      { funcName: 'design.template.update.designed', oldName: 'design.template.updated.designed', usedBefore: '1.2' }
    ]
  }
};

const params = {
  ios: {
    webrand: [],
    desygner: [
      { funcName: 'openInNewWindow', usedBefore: '1.1.2', map: function (p) { return { cmd: p.cmd, url: p.params.url }; } },
      { funcName: 'editor_loaded', usedBefore: '1.1.2', map: function (p) { return { cmd: p.cmd, book_id: p.params.book_id }; } }
    ]
  },
  android: {
    webrand: [],
    desygner: [
      { funcName: 'catchFile', usedBefore: '1.0.3', map: function (p) { return [p.params.url]; } },
      { funcName: 'photoUpload', usedBefore: '1.0.3', map: function (p) { return [p.params.size_name]; } },
      { funcName: 'editorLoaded', usedBefore: '1.0.3', map: function (p) { return [p.params.book_id]; } },
      { funcName: 'showTeam', usedBefore: '1.0.3', map: function (p) { return [p.params.x, p.params.y]; } }
    ]
  }
};

module.exports = {
  androidMethodName: _.partial(oldNameReplace, methods.android),
  iosMethodName: _.partial(oldNameReplace, methods.ios),
  androidParameters: _.partial(oldParametersReplace, params.android),
  iosParameters: _.partial(oldParametersReplace, params.ios),
  supportsCreateReturn: function (appBridge) {
    return (window.Android && !appBridge.version.isLowerThan('2.2.1')) ||
      !window.Android || appBridge.version.isApp('webrand') || appBridge.version.isApp('pdf');
  },
  supportsRestrictionsFacade: function (appBridge) {
    return (window.Android && !appBridge.version.isLowerThan('2.2')) ||
      (!window.Android && !appBridge.version.isLowerThan('2.3')) ||
      appBridge.version.isApp('webrand') || appBridge.version.isApp('pdf');
  },
  supportsDesignFacade: function (appBridge) {
    return (window.Android && appBridge.version.isGreaterThan('1.0.2')) ||
      (!window.Android && appBridge.version.isGreaterThan('1.1.1')) ||
      appBridge.version.isApp('webrand') || appBridge.version.isApp('pdf');
  },
  supportsEditorFacade: function (appBridge) {
    return (window.Android && !appBridge.version.isLowerThan('1.1')) ||
      (!window.Android && !appBridge.version.isLowerThan('1.2')) ||
      appBridge.version.isApp('webrand') || appBridge.version.isApp('pdf');
  },
  supportsProjectFacade: function (appBridge) {
    return (window.Android && !appBridge.version.isLowerThan('1.1')) ||
      (!window.Android && !appBridge.version.isLowerThan('1.2')) ||
      appBridge.version.isApp('webrand') || appBridge.version.isApp('pdf');
  },
  events: function (appBridge) {
    // var isOldVersion = ( window.Android && appBridge.version.isLowerThan('1.0.4') )
    //   || ( !window.Android && appBridge.version.isLowerThan('1.1.2') );
    //
    // if(true || isOldVersion) {
    const $ik = $('#ik-editor');

    appBridge.on = _.bind($ik.on, $ik);
    appBridge.off = _.bind($ik.off, $ik);
    appBridge.once = _.bind($ik.one, $ik);
    appBridge.trigger = _.bind($ik.trigger, $ik);
    // }
  }
};

function oldNameReplace (data, currentName) {
  const AppBridge = require('./bridge');
  const oldMethods = _.where(data[AppBridge.version.getApp()], { funcName: currentName });

  _.any(oldMethods, function (oldMethod) {
    if (AppBridge.version.isLowerThan(oldMethod.usedBefore)) {
      console.log('We will use: ' + oldMethod.oldName);
      currentName = oldMethod.oldName;
      return true;
    }
  });

  return currentName;
}

function oldParametersReplace (data, params) {
  const AppBridge = require('./bridge');
  const oldParameters = _.where(data[AppBridge.version.getApp()], { funcName: params.cmd });

  _.any(oldParameters, function (oldParams) {
    if (AppBridge.version.isLowerThan(oldParams.usedBefore)) {
      params = oldParams.map(params);
      return true;
    }
  });

  return params;
}
